import { render } from "./ListDirectBuy.vue?vue&type=template&id=768e15e1"
import script from "./ListDirectBuy.vue?vue&type=script&lang=js"
export * from "./ListDirectBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__